/* pooch-cardstock.js — 12 Oct
   Kaam: homepage / collection ke product card se "Add to Petkart" par zyada quantity daalo
   aur stock kam ho, to Shopify utna hi daalta hai jitna stock hai — par card par koi message
   nahi aata tha (product page par aata hai). Ab card par bhi wahi message dikhta hai.

   Message ka text Shopify ka apna hota hai (jaise "Only 1 item was added to your cart due to
   availability.") — yahan kuch likha nahi hai, isliye language/text apne aap sahi rehta hai.
   Message button ke upar tairta hai (absolute), card ki oonchai nahi badalti. 5 second me hat jaata hai.

   Band karna ho: snippets/stylesheets.liquid me is file ka script tag hata do. */
(function () {
  var SHOW_FOR = 5000;

  function cardOf(el) {
    return el && el.closest ? el.closest('product-card, .product-card') : null;
  }

  function show(form, text) {
    var host = form.closest('.quick-add') || form;
    var box = host.querySelector(':scope > .pooch-card-error');
    if (!box) {
      box = document.createElement('div');
      box.className = 'pooch-card-error';
      box.setAttribute('role', 'alert');
      box.innerHTML =
        '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="10" fill="#EB001B"/>' +
        '<path d="M10 5v6" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/><circle cx="10" cy="14.6" r="1.3" fill="#fff"/></svg>' +
        '<span></span>';
      host.appendChild(box);
    }
    box.querySelector('span').textContent = text;
    box.classList.add('is-on');
    clearTimeout(box.__t);
    box.__t = setTimeout(function () { box.classList.remove('is-on'); }, SHOW_FOR);
  }

  // capture: event bubble na kare tab bhi pakda jaaye
  window.addEventListener('shopify:cart:error', function (e) {
    var form = e.target;
    if (!form || !cardOf(form)) return;            // sirf product card; product page apna message khud dikhata hai
    if (form.refs && form.refs.addToCartTextError) return;
    var text = e.error || (e.detail && (e.detail.error || e.detail.message)) || '';
    if (text) show(form, text);
  }, true);
})();
